import scrollTo from 'utils/scrollTo';

class SubNavigation {
  constructor(options) {
    this._options = { ...SubNavigation.options, ...options };
    this._init();
  }

  static options = {
    pace: 350,
  };

  _cacheSelectors() {
    this._menu = document.querySelector('.sub-navigation');
    this._anchorLinks = [].slice.call(document.querySelectorAll('.anchor-link'));
    this._anchors = [].slice.call(document.querySelectorAll('[data-anchor]'));
  }

  _addEventListeners() {
    this._anchorLinks.forEach((anchorLink) =>
      anchorLink.addEventListener('click', (e) => {
        e.preventDefault();
        const offset = this._menu.scrollHeight;
        const hash = anchorLink.href.split('#');
        /* eslint-disable-next-line */
        document.querySelector(`[id="${hash[1]}"]`) &&
          scrollTo(document.querySelector(`[id="${hash[1]}"]`), offset, this._options.pace);
      })
    );
  }

  _init() {
    this._cacheSelectors();
    this._addEventListeners();

    const anchorObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((anchor) => {
          const { isIntersecting } = anchor;
          if (isIntersecting) {
            this._menu
              .querySelector(`[href="#${anchor.target.id}"]`)
              .setAttribute('data-active', 'true');
          } else {
            this._menu
              .querySelector(`[href="#${anchor.target.id}"]`)
              .setAttribute('data-active', 'false');
          }
        });
      },
      {
        threshold: 0,
      }
    );

    this._anchors.forEach((anchor) => anchorObserver.observe(anchor));
  }
}

export default SubNavigation;
